import React from 'react';

import Hero from 'ui-kit/hero/hero';

import './style.css';

const Page = ({
    className,
    heroImgSrc,
    heroImgAlt,
    heroTitle,
    heroLinkTo,
    heroLinkLabel,
    heroSize,
    heroText,
    noHero,
    children,
    pageStyle,
    pageContentStyle,
    variant
}) => {
    return (
        <div className={`page ${className ?? ''} ${variant ?? ''}`} style={pageStyle}>
            {!noHero && (
                <Hero
                    title={heroTitle}
                    text={heroText}
                    imgSrc={heroImgSrc}
                    imgAlt={heroImgAlt}
                    linkLabel={heroLinkLabel}
                    linkTo={heroLinkTo}
                    size={heroSize}
                />
            )}
            {children && (
                <div className="page-content" style={pageContentStyle}>
                    {children}
                </div>
            )}
        </div>
    );
};

export default Page;
